import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box, ToggleButton, ToggleButtonGroup, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import GridViewIcon from '@mui/icons-material/GridView';
import ReorderIcon from '@mui/icons-material/Reorder';
import AddSensorsPopup from './AddSensorsPopup/AddSensorsPopup';
import SensorsView from './SensorsView/SensorsView';
import Container from './styles/Container';
import useAuth from '../../../../shared/lib/hooks/useAuth';
import { useGetAppUserResourceIdQuery } from '../../../../entities/account/appUsersResource/redux/appUsersResource.api';
import { useGetSensorsValuesTypesQuery } from '../../../../entities/equipments/sensorsValuesTypesResource/redux/sensorsValuesTypesResource.api';
import ActionsWrapper from './styles/ActionsWrapper';

function SensorsState({ liveSensorValues, vehicleId }) {
  const { user } = useAuth();
  const { data: dataAppUserResourceId } = useGetAppUserResourceIdQuery({
    id: user.appUserId,
  });
  const appUser = dataAppUserResourceId?.data;

  const { data: { data: allSensors = [] } = {} } = useGetSensorsValuesTypesQuery({"isRaw.equals":"false"});

  const [sensors, setSensors] = useState([]);
  const [view, setView] = useState('grid');
  const [open, setOpen] = useState(false);

  const sensorsWithValues = useMemo(() => {
    if (!sensors.length) return sensors;

    const liveMap = new Map(liveSensorValues.map((s) => [s.sensorId, s]));

    return sensors.map((sensor) => {
      const live = liveMap.get(sensor.sensorTypeId);
      return {
        ...sensor,
        value: live?.value ?? null,
        timestamp: (live?.sendTime || live?.timestamp) ?? null,
      };
    });
  }, [sensors, liveSensorValues]);

  useEffect(() => {
    if (!appUser || !allSensors) return;

    const ids =
      appUser?.customAugmentationEx?.view?.vsensor
        ?.split(',')
        .map((s) => s.trim())
        .filter(Boolean)
        .map(Number) || [];

    // Для сохранения порядка выбранных сенсоров
    const sensorsMap = new Map(allSensors.map((s) => [s.sensorTypeId, s]));
    setSensors(ids.map((id) => sensorsMap.get(id)).filter(Boolean));
  }, [appUser, allSensors]);

  return (
    <Container>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
        <ActionsWrapper>
          <ToggleButtonGroup size="small" value={view} exclusive onChange={(_, value) => setView(value)}>
            <ToggleButton value="list">
              <ReorderIcon fontSize="small" />
            </ToggleButton>
            <ToggleButton value="grid">
              <GridViewIcon fontSize="small" />
            </ToggleButton>
          </ToggleButtonGroup>
          <IconButton title="Редактировать" onClick={() => setOpen(true)}>
            <EditIcon />
          </IconButton>
        </ActionsWrapper>
      </Box>

      <Box
        sx={{
          overflowY: 'scroll',
          pr: '4px',
        }}
      >
        <SensorsView sensors={sensorsWithValues} view={view} />
      </Box>

      <AddSensorsPopup open={open} onClose={() => setOpen(false)} value={sensors} onApply={setSensors} vehicleId={vehicleId} />
    </Container>
  );
}

SensorsState.propTypes = {
  liveSensorValues: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  vehicleId: PropTypes.number
};

SensorsState.defaultProps = {
  vehicleId: null
}

export default SensorsState;
